import { Injectable } from "@angular/core";
import { ActividadCliente } from "@shared/enums/ActividadCliente";
import { AgrupacionRemitos } from "@shared/enums/agrupacionRemitos";
import { CondicionIIBB } from "@shared/enums/condicionIIBB";
import { CondicionIVA } from "@shared/enums/condicionIVA";
import { TipoCuenta } from "@shared/enums/tipoCuenta";
import { TipoDocumento } from "@shared/enums/tipoDocumento";
import { TipoEntregaFactura } from "@shared/enums/tipoEntregaFactura";
import { TipoMoneda } from "@shared/enums/tipoMoneda";
import { Ubicacion } from '@shared/models/cliente/Ubicacion';
import { Cuenta } from '@shared/models/cliente/Cuenta';
import { Responsable } from '@shared/models/cliente/Responsable';
import { Cliente } from "@shared/models/cliente/Cliente";
import { formatDate } from '@angular/common';
import { EstadoModificacion } from "@shared/enums/EstadoModificacion";
import { CBU } from "@shared/models/cliente/CBU";
import { CodigoUbicacion } from "@shared/enums/codigoUbicacion";

@Injectable({
  providedIn: 'root'
})
export class UtilClientes {
  obtenerDescripcionTipoDocumento(tipoDoc) {
    if (tipoDoc == TipoDocumento.DNI) {
      return "DNI";
    } else if (tipoDoc == TipoDocumento.CUIL) {
      return "CUIL";
    } else if (tipoDoc == TipoDocumento.CUIT) {
      return "CUIT";
    } else if (tipoDoc == TipoDocumento.Extranjero) {
      return "EXTRANJERO";
    } else {
      return "-";
    }
  }

  obtenerDescripcionCondicionIva(condIva) {
    if (condIva == CondicionIVA.ConsumidorFinal) {
      return "Consumidor Final";
    } else if (condIva == CondicionIVA.ResponsableInscripto) {
      return "Responsable Inscripto";
    } else {
      return "-";
    }
  }

  obtenerDescripcionCondicionVenta(tipoCuenta) {
    if (tipoCuenta == TipoCuenta.PrevioPago) {
      return "Previo Pago";
    } else if (tipoCuenta == TipoCuenta.CuentaCorriente) {
      return "Cuenta Corriente";
    } else if (tipoCuenta == TipoCuenta.Donacion) {
      return "Donación";
    } else if (tipoCuenta == TipoCuenta.ConsumoInterno) {
      return "Consumo Interno";
    } else if (tipoCuenta == TipoCuenta.Anticipada) {
      return "Anticipada"
    } else {
      return "Contado";
    }
  }

  obtenerDescripcionMoneda(tipoMoneda) {
    if (tipoMoneda == TipoMoneda.PES) {
      return "Pesos $";
    } else if (tipoMoneda == TipoMoneda.USD) {
      return "Dolares USD";
    } else {
      return "-";
    }
  }

  obtenerDescripcionTipoEntregaFactura(tipoEntregaFactura) {
    if (tipoEntregaFactura == TipoEntregaFactura.Fisico) {
      return "Fisico";
    } else if (tipoEntregaFactura == TipoEntregaFactura.Email) {
      return "Mail";
    } else if (tipoEntregaFactura == TipoEntregaFactura.Ambos) {
      return "Mail y fisico";
    } else {
      return "-";
    }
  }

  obtenerDescripcionAgrupacionRemitos(tipoAgrupacionRemitos) {
    if (tipoAgrupacionRemitos == AgrupacionRemitos.Aeroplanta) {
      return "Aeroplanta";
    } else if (tipoAgrupacionRemitos == AgrupacionRemitos.Provincia) {
      return "Provincia";
    } else if (tipoAgrupacionRemitos == AgrupacionRemitos.DireccionEntrega) {
      return "Direccion de entrega";
    } else if (tipoAgrupacionRemitos == AgrupacionRemitos.Remito) {
      return "Remitos";
    } else {
      return "-";
    }
  }

  obtenerDescripcionActividadPad(actividadPad) {
    return ActividadCliente[actividadPad];
  }

  obtenerDescripcionCondicionIIBB(condicionIIBB) {
    return CondicionIIBB[condicionIIBB];
  }

  obtenerDescripcionEstadoModificacion(estado) {
    if (estado == EstadoModificacion.Aprobado) {
      return "APROBADO";
    } else if (estado == EstadoModificacion.Rechazado) {
      return "RECHAZADO";
    } else if (estado == EstadoModificacion.Pendiente) {
      return "PENDIENTE";
    }else{
      return "-";
    }
  }

  cambioResponsable(viejo: Responsable, nuevo: Responsable): boolean {

    if (viejo == null || viejo.nombreCompleto != nuevo.nombreCompleto) {
      return true;
    }

    if (viejo == null || viejo.email != nuevo.email) {
      return true;
    }

    if (viejo == null || viejo.telefono != nuevo.telefono) {
      return true;
    }

    return false;
  }

  cambioCbu(viejo: CBU, nuevo: CBU): boolean {
    if(viejo.cbu != nuevo.cbu){
      return true;
    }
    if(viejo.enUso != nuevo.enUso){
      return true;
    }
    if (viejo == null && nuevo !=null){
      return true;
    }
    return false;
  }

  cambioDireccionFiscal(viejo: Ubicacion, nuevo: Ubicacion): boolean {
    if(viejo?.ciudad === null){
      return true
    }
    if (viejo?.ciudad.codigoPostal != nuevo.ciudad.codigoPostal) {
      return true;
    }
    if (viejo?.ciudad.provincia != nuevo.ciudad.provincia) {
      return true;
    }
    if (viejo?.calle != nuevo.calle) {
      return true;
    }

    if (viejo?.numero != nuevo.numero) {
      return true;
    }

    if (viejo?.piso != nuevo.piso) {
      return true;
    }

    if (viejo?.departamento != nuevo.departamento) {
      return true;
    }

    return false;
  }

  cambioPeriodoFacturacion(viejo, nuevo) {
    if (viejo == null) {
      return true;
    }

    if (nuevo == null) {
      return true;
    }

    if (viejo.id != nuevo.id) {
      return true;
    }

    return false;
  }

  cambioCuentaSAP(viejo, nuevo) {
    if (viejo == null && nuevo != null) {
      return true;
    }

    if (nuevo == null && viejo != null) {
      return true;
    }

    if (viejo != nuevo) {
      return true;
    }

    return false;
  }

  checkAmbosNulos(viejo, nuevo) {
    if (viejo == null && nuevo == null) {
      return true;
    }

    return false;
  }

  checkAmbosVacios(viejo, nuevo) {
    if (viejo == null && nuevo === null) {
      return true;
    }

    if (viejo != null && nuevo != null && viejo.length == 0 && nuevo.length == 0) {
      return true;
    }

    if (viejo == null && nuevo.lenght == 0) {
      return true;
    }

    if (nuevo == null && viejo.lenght == 0) {
      return true;
    }

    return false;
  }

  checkCBUEnUso(c:CBU): string{
    let sEnUso :string = "";
    sEnUso = c.enUso ? " - En Uso" : " - No usado";
    return sEnUso
  }

  compararClientes(viejo: Cliente, nuevo: Cliente){
    const modificaciones: { valorViejo: string, valorNuevo: string } [] = [];

    if(viejo.razonSocial != nuevo.razonSocial){
      const valorViejo = "Razon Social: " + viejo.razonSocial;
      const valorNuevo = "Razon Social: " + nuevo.razonSocial;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(viejo.tipoDocumento != nuevo.tipoDocumento){
      const valorViejo = "Tipo Doc.: " + this.obtenerDescripcionTipoDocumento(viejo.tipoDocumento);
      const valorNuevo = "Tipo Doc.: " + this.obtenerDescripcionTipoDocumento(nuevo.tipoDocumento);
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(viejo.numeroDocumento != nuevo.numeroDocumento){
      const valorViejo = "Nro. Doc.: " + viejo.numeroDocumento;
      const valorNuevo = "Nro. Doc.: " + nuevo.numeroDocumento;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if( (! this.checkAmbosNulos(viejo.responsable, nuevo.responsable)) && this.cambioResponsable(viejo.responsable, nuevo.responsable)){
      const valorViejo = "Responsable: " + (viejo.responsable == null ? "-" : viejo.responsable.nombreCompleto + " / " + viejo.responsable.email + " / " + viejo.responsable.telefono) ;
      const valorNuevo = "Responsable: " + nuevo.responsable.nombreCompleto + " / " + nuevo.responsable.email + " / " + nuevo.responsable.telefono ;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if( (! this.checkAmbosNulos(viejo.condicionIva, nuevo.condicionIva)) && viejo.condicionIva.id != nuevo.condicionIva.id){
      const valorViejo = "Condición IVA: " + viejo.condicionIva.descripcion;
      const valorNuevo = "Condición IVA: " + nuevo.condicionIva.descripcion;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(viejo.ctaSap != nuevo.ctaSap){
      const valorViejo = "Nro. cuenta SAP.: " + (viejo.ctaSap ? viejo.ctaSap : "-");
      const valorNuevo = "Nro. cuenta SAP.: " + nuevo.ctaSap;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(viejo.ctA_CTC != nuevo.ctA_CTC){
      const valorViejo = "Nro. cuenta CTC.: " + (viejo.ctA_CTC ? viejo.ctA_CTC : "-");
      const valorNuevo = "Nro. cuenta CTC.: " + nuevo.ctA_CTC;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if( (! this.checkAmbosNulos(viejo.subArea, nuevo.subArea)) && viejo.subArea?.area?.id != nuevo.subArea?.area?.id){
      const valorViejo = "Área: " + (viejo.subArea?.area?.descripcion != null ? viejo.subArea.area.descripcion : "-");
      const valorNuevo = "Área: " + nuevo.subArea?.area?.descripcion;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if( (! this.checkAmbosNulos(viejo.subArea, nuevo.subArea)) && viejo.subArea?.id != nuevo.subArea?.id){
      const valorViejo = "Segmento: " + (viejo.subArea?.descripcion != null ? viejo.subArea.descripcion : "-");
      const valorNuevo = "Segmento: " + nuevo.subArea?.descripcion;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if( (! this.checkAmbosNulos(viejo.direccionFiscal, nuevo.direccionFiscal)) && this.cambioDireccionFiscal(viejo.direccionFiscal, nuevo.direccionFiscal)){
      const valorViejo = "Dirección fiscal: " + (viejo.direccionFiscal?.calle != null ? viejo.direccionFiscal?.calle : "") + " " + (viejo.direccionFiscal?.numero != null ? viejo.direccionFiscal?.numero : "")  + " " + (viejo.direccionFiscal?.piso != null ? viejo.direccionFiscal?.piso : "") + " " + (viejo.direccionFiscal?.departamento != null ? viejo.direccionFiscal?.departamento : "") + ", " + (viejo.direccionFiscal?.ciudad === null ? "" : viejo.direccionFiscal?.ciudad.nombre) + " (" + ((viejo.direccionFiscal?.ciudad === null) ? "" : viejo.direccionFiscal?.ciudad?.codigoPostal === null ? "" : viejo.direccionFiscal?.ciudad.codigoPostal ) + ")" ;
      const valorNuevo = "Dirección fiscal: " + nuevo.direccionFiscal.calle + " " + nuevo.direccionFiscal.numero  + " " + nuevo.direccionFiscal.piso + " " + nuevo.direccionFiscal.departamento + ", " + nuevo.direccionFiscal.ciudad.nombre + " (" + nuevo.direccionFiscal.ciudad.codigoPostal + ")";
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(viejo.actividadPAD != nuevo.actividadPAD){
      const valorViejo = "Actividad PAD: " + this.obtenerDescripcionActividadPad(viejo.actividadPAD);
      const valorNuevo = "Actividad PAD: " + this.obtenerDescripcionActividadPad(nuevo.actividadPAD);
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }
/*
    if( (! this.checkAmbosNulos(viejo.grupoCliente, nuevo.grupoCliente)) && viejo.grupoCliente.id != nuevo.grupoCliente.id){
      var valorViejo = "Segmento: " + viejo.grupoCliente.descripcion;
      var valorNuevo = "Segmento: " + nuevo.grupoCliente.descripcion;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }
*/
    if(viejo.percepcionIVADif != nuevo.percepcionIVADif){
      const valorViejo = "Percep. IVA dif.: " + viejo.percepcionIVADif;
      const valorNuevo = "Percep. IVA dif.: " + nuevo.percepcionIVADif;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(viejo.fechaPercepcionIVADif != nuevo.fechaPercepcionIVADif){
      const valorViejo = "Fecha Percep. IVA dif.: " + formatDate(viejo.fechaPercepcionIVADif, 'yyyy/MM/dd', 'en');
      const valorNuevo = "Fecha Percep. IVA dif.: " + formatDate(nuevo.fechaPercepcionIVADif, 'yyyy/MM/dd', 'en');
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(viejo.clienteObservado != nuevo.clienteObservado){
      const valorViejo = "Cliente observado: " + (viejo.clienteObservado ? "Si" : "No");
      const valorNuevo = "Cliente observado: " + (nuevo.clienteObservado ? "Si" : "No");
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(viejo.activo != nuevo.activo){
      const valorViejo = "Activo: " + (viejo.activo ? "Si" : "No");
      const valorNuevo = "Activo: " + (nuevo.activo ? "Si" : "No");
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if( (! this.checkAmbosNulos(viejo.grupoCliente, nuevo.grupoCliente)) && (viejo.grupoCliente?.codigo != nuevo.grupoCliente?.codigo)){
      const valorViejo = "Agrupacion Serc: " + (viejo.grupoCliente != null ? viejo.grupoCliente.descripcion : "null");
      const valorNuevo = "Agrupacion Serc: " + (nuevo.grupoCliente != null ? nuevo.grupoCliente.descripcion : "null");
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }
    // Direcciones entrega
    if((! this.checkAmbosNulos(viejo.direccionesEntrega, nuevo.direccionesEntrega)) && (! this.checkAmbosVacios(viejo.direccionesEntrega, nuevo.direccionesEntrega)) ){

      let valorViejo = "Dir. Entrega: ";
      if(viejo.direccionesEntrega == null || viejo.direccionesEntrega.length == 0){
        valorViejo = "Sin direcciones entrega";
      }else{
        for(const dirEntrega of viejo.direccionesEntrega){
          valorViejo += this.descripcionCodigoUbicacion(dirEntrega.codigoUbicacion) + " " + dirEntrega.calle + " " + dirEntrega.numero + " " + dirEntrega.piso + " " + dirEntrega.departamento +", " + dirEntrega.ciudad.nombre + " (" + dirEntrega.ciudad.codigoPostal + ")<br/>";
        }
      }

      let valorNuevo = "Dir. Entrega: ";
      if(nuevo.direccionesEntrega == null || nuevo.direccionesEntrega.length == 0){
        valorNuevo = "Sin direcciones entrega";
      }else{
        for(const dirEntrega of nuevo.direccionesEntrega){
          valorNuevo += this.descripcionCodigoUbicacion(dirEntrega.codigoUbicacion) + " " + dirEntrega.calle + " " + dirEntrega.numero + " " + dirEntrega.piso + " " + dirEntrega.departamento + ", " + dirEntrega.ciudad.nombre +" (" + dirEntrega.ciudad.codigoPostal + ")<br/>";
        }
      }

      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    // Comerciales
    if( (! this.checkAmbosNulos(viejo.comerciales, nuevo.comerciales)) && (! this.checkAmbosVacios(viejo.comerciales, nuevo.comerciales)) ){
      let valorViejo = "";
      if(viejo.comerciales == null || viejo.comerciales.length == 0){
        valorViejo = "Sin comerciales";
      }else{
        for(const c of viejo.comerciales){
          valorViejo += c + ". ";
        }
      }

      let valorNuevo = "";
      if(nuevo.comerciales == null || nuevo.comerciales.length == 0){
        valorNuevo = "Sin comerciales";
      }else{
        for(const c of nuevo.comerciales){
          valorNuevo += c + ". ";
        }
      }

      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    // Ejecutivos cuenta
    if(
      (!this.checkAmbosNulos(viejo.ejecutivoCuenta, nuevo.ejecutivoCuenta)) &&
      (!this.checkAmbosVacios(viejo.ejecutivoCuenta, nuevo.ejecutivoCuenta)) &&
      (viejo.ejecutivoCuenta?.nombresCompletos?.trim() ?? '') !==
      (nuevo.ejecutivoCuenta?.nombresCompletos?.trim() ?? '')
    ){
      const valorViejo = "Ejecutivo Cuenta: " + viejo.ejecutivoCuenta?.nombresCompletos ?? '-';
      const valorNuevo = "Ejecutivo Cuenta: " + nuevo.ejecutivoCuenta?.nombresCompletos ?? '-';
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

     // IIBB
    if((! this.checkAmbosNulos(viejo.configuracionProvincialImp, nuevo.configuracionProvincialImp)) && (! this.checkAmbosVacios(viejo.configuracionProvincialImp, nuevo.configuracionProvincialImp)) ){

      let valorViejo = "";
      if(viejo.configuracionProvincialImp == null || viejo.configuracionProvincialImp.length == 0){
        valorViejo = "Sin config. IIBB";
      }else{
        viejo.configuracionProvincialImp.sort((a, b) => a.provincia.codigo.localeCompare(b.provincia.codigo));
        for(const config of viejo.configuracionProvincialImp){
          const coeficienteViejo = (config.condicionIIBB == CondicionIIBB.ConvenioMultilateral && config.coeficienteConvenioMultilateral) ? ` - Coeficiente convenio multilateral: ${config.coeficienteConvenioMultilateral.toFixed(3)}` : '' ; // para que el coeficiente se muestre solo si la condicion de IIBB es convenio multilateral
          valorViejo += config.provincia.codigo + ": Num. IIBB: " + config.numeroIIBB + " - " + this.obtenerDescripcionCondicionIIBB(config.condicionIIBB) + coeficienteViejo + " - Alicuota: " + (config.alicuotaDiferencial == null ? " SIN ALICUOTA <br/>" : (config.alicuotaDiferencial.alicuota + " (" + formatDate(config.alicuotaDiferencial.fechaDesde, 'yyyy/MM/dd', 'en') + "-" + formatDate(config.alicuotaDiferencial.fechaHasta, 'yyyy/MM/dd', 'en') +  ") <br/>"))
        }
      }

      let valorNuevo = "";
      if(nuevo.configuracionProvincialImp == null || nuevo.configuracionProvincialImp.length == 0){
        valorNuevo = "Sin  config. IIBB";
      }else{
        nuevo.configuracionProvincialImp.sort((a, b) => a.provincia.codigo.localeCompare(b.provincia.codigo));
        for(const config of nuevo.configuracionProvincialImp){
          const coeficienteNuevo = (config.condicionIIBB == CondicionIIBB.ConvenioMultilateral && config.coeficienteConvenioMultilateral) ? ` - Coeficiente convenio multilateral: ${config.coeficienteConvenioMultilateral.toFixed(3)}` : '' ; // para que el coeficiente se muestre solo si la condicion de IIBB es convenio multilateral
          valorNuevo += config.provincia.codigo +  ": Num. IIBB: "  + config.numeroIIBB + " - " + this.obtenerDescripcionCondicionIIBB(config.condicionIIBB) + coeficienteNuevo + " - Alicuota: " + (config.alicuotaDiferencial == null ? " SIN ALICUOTA <br/>" : (config.alicuotaDiferencial.alicuota + " (" + formatDate(config.alicuotaDiferencial.fechaDesde, 'yyyy/MM/dd', 'en') + "-" + formatDate(config.alicuotaDiferencial.fechaHasta, 'yyyy/MM/dd', 'en') + ") <br/>"))
        }
      }

      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo});
    }

    // CBU
    viejo.cbUs.sort((a , b) => a.tipoBancoInterlocutor - b.tipoBancoInterlocutor);
    nuevo.cbUs.sort((a , b) => a.tipoBancoInterlocutor - b.tipoBancoInterlocutor);
    if((! this.checkAmbosNulos(viejo.cbUs, nuevo.cbUs)) && (! this.checkAmbosVacios(viejo.cbUs, nuevo.cbUs)) ){
      for (let c = 0; c < nuevo.cbUs.length; c++){
        let valorViejo = "";
        let valorNuevo = "";
        if(viejo.cbUs[c] == null || viejo.cbUs.length == 0){
          valorViejo = "Sin CBU";
          valorNuevo += "CBU: " + nuevo.cbUs[c].cbu + " - Banco interlocutor: " + nuevo.cbUs[c].tipoBancoInterlocutor + this.checkCBUEnUso(nuevo.cbUs[c]);
          modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo});
        }else{
          if(this.cambioCbu(viejo.cbUs[c],nuevo.cbUs[c])){
            valorViejo += "CBU: " + viejo.cbUs[c].cbu + " - Banco interlocutor: " + viejo.cbUs[c].tipoBancoInterlocutor + this.checkCBUEnUso(viejo.cbUs[c]);
            valorNuevo += "CBU: " + nuevo.cbUs[c].cbu + " - Banco interlocutor: " + nuevo.cbUs[c].tipoBancoInterlocutor + this.checkCBUEnUso(nuevo.cbUs[c]);
            modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo});
          }
        }
      }
    }

    if(viejo.viaDePago != nuevo.viaDePago){
      let valorViejo="";
      if (viejo.viaDePago == null)
      {
        valorViejo = "Sin Via de Pago";
      }else{
        valorViejo = viejo.viaDePago.descripcion;
      }

      let valorNuevo = "";
      if (nuevo.viaDePago == null)
      {
        valorNuevo = "Sin Via de Pago";
      }else{
        valorNuevo = nuevo.viaDePago.descripcion;
      }

      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    return modificaciones;
  }

  compararCuentas(cuentaViejo: Cuenta, cuentaNuevo: Cuenta){
    const modificaciones: { valorViejo: string, valorNuevo: string } [] = [];

    if(cuentaViejo == null || cuentaViejo.ctA_SGC != cuentaNuevo.ctA_SGC){
      const valorViejo = "Nro. Cuenta: " + (cuentaViejo == null ? "-" : cuentaViejo.ctA_SGC);
      const valorNuevo = "Nro. Cuenta: " + cuentaNuevo.ctA_SGC;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.descripcion != cuentaNuevo.descripcion){
      const valorViejo = "Identificador: " + (cuentaViejo == null ? "-" : cuentaViejo.descripcion);
      const valorNuevo = "Identificador: "  + cuentaNuevo.descripcion;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.correosIATA != cuentaNuevo.correosIATA) {
      const valorViejo = "Correos IATA: " + (cuentaViejo == null ? "-" : cuentaViejo.correosIATA);
      const valorNuevo = "Correos IATA: " + cuentaNuevo.correosIATA;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.condicionPago != cuentaNuevo.condicionPago){
      const valorViejo = "Plazo pago : " + (cuentaViejo?.condicionPago?.codigo == null ? "-" : cuentaViejo.condicionPago.codigo + " - " + cuentaViejo.condicionPago.descripcion);
      const valorNuevo = "Plazo pago : "  + cuentaNuevo.condicionPago.codigo + " - " + cuentaNuevo.condicionPago.descripcion;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.tipoCuenta != cuentaNuevo.tipoCuenta){
      const valorViejo = "Condición venta: " + (cuentaViejo == null ? "-" : this.obtenerDescripcionCondicionVenta(cuentaViejo.tipoCuenta));
      const valorNuevo = "Condición venta: "  + this.obtenerDescripcionCondicionVenta(cuentaNuevo.tipoCuenta);
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.moneda != cuentaNuevo.moneda){
      const valorViejo = "Moneda: " + (cuentaViejo == null ? "-" : this.obtenerDescripcionMoneda(cuentaViejo.moneda));
      const valorNuevo = "Moneda: "  + this.obtenerDescripcionMoneda(cuentaNuevo.moneda);
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.tipoEntregaFactura != cuentaNuevo.tipoEntregaFactura){
      const valorViejo = "Tipo entrega: " + (cuentaViejo == null ? "-" : this.obtenerDescripcionTipoEntregaFactura(cuentaViejo.tipoEntregaFactura));
      const valorNuevo = "Tipo entrega: "  + this.obtenerDescripcionTipoEntregaFactura(cuentaNuevo.tipoEntregaFactura);
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.agrupacionRemitos != cuentaNuevo.agrupacionRemitos){
      const valorViejo = "Agrupación remitos: " + (cuentaViejo == null ? "-" : this.obtenerDescripcionAgrupacionRemitos(cuentaViejo.agrupacionRemitos));
      const valorNuevo = "Agrupación remitos: "  + this.obtenerDescripcionAgrupacionRemitos(cuentaNuevo.agrupacionRemitos);
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    // Periodo facturacion puede ser nulo
    if(cuentaViejo == null || ((! this.checkAmbosNulos(cuentaViejo.periodoFacturacion, cuentaNuevo.periodoFacturacion))  && this.cambioPeriodoFacturacion(cuentaViejo.periodoFacturacion, cuentaNuevo.periodoFacturacion)) ){
      const valorViejo = "Periodo facturación: " + (cuentaViejo == null || cuentaViejo.periodoFacturacion == null ? "-" : cuentaViejo.periodoFacturacion.descripcion);
      const valorNuevo = "Periodo facturación: "  + (cuentaNuevo.periodoFacturacion == null ? "-" : cuentaNuevo.periodoFacturacion.descripcion);
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.notificaPorEmail != cuentaNuevo.notificaPorEmail){
      const valorViejo = "Notificar por mail: " + (cuentaViejo == null ? "-" : cuentaViejo.notificaPorEmail ? "Si" : "No");
      const valorNuevo = "Notificar por mail: "  + (cuentaNuevo.notificaPorEmail ? "Si" : "No");
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.email != cuentaNuevo.email){
      const valorViejo = "Email: " + (cuentaViejo == null ? "-" : cuentaViejo.email);
      const valorNuevo = "Email: "  + cuentaNuevo.email;
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || (! this.checkAmbosNulos(cuentaViejo.ctaSap, cuentaNuevo.ctaSap)  && this.cambioCuentaSAP(cuentaViejo.ctaSap, cuentaNuevo.ctaSap)) ){
      const valorViejo = "Cuenta SAP: " + (cuentaViejo == null || cuentaViejo.ctaSap == null ? "-" : cuentaViejo.ctaSap);
      const valorNuevo = "Cuenta SAP: "  + (cuentaNuevo.ctaSap == null ? "-" : cuentaNuevo.ctaSap);
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    if(cuentaViejo == null || cuentaViejo.activo != cuentaNuevo.activo){
      const valorViejo = "Activo: " + (cuentaViejo == null ? "-" : cuentaViejo.activo ? "Si" : "No");
      const valorNuevo = "Activo: " + (cuentaNuevo.activo ? "Si" : "No");
      modificaciones.push({valorViejo: valorViejo, valorNuevo: valorNuevo})
    }

    return modificaciones;
  }

  descripcionCodigoUbicacion(codigoUbicacion: number){
    if(codigoUbicacion == CodigoUbicacion.entregaFactura){
      return "Entrega Factura";
    }else if(codigoUbicacion == CodigoUbicacion.entregaProducto){
      return "Entrega Producto";
    }else if(codigoUbicacion == CodigoUbicacion.entregaProductoFactura){
      return "Entrega ProductoFactura";
    }else if(codigoUbicacion == CodigoUbicacion.fiscal){
      return "Fiscal";
    }else if(codigoUbicacion == CodigoUbicacion.fiscalEntregaProductoFactura){
      return "Fiscal Entrega Producto Factrua";
    }else {
      return "";
    }
  }
}

